import { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { postData } from '../utils/api';
import { DEVICE_ID_KEY, getOrCreateDeviceId } from '../utils/registrationMetadata';
import useLocalStorage from './useLocalStorage';
import { usePromoCode } from './usePromoCode';

export const usePromoCodeTracking = () => {
  const [deviceId] = useLocalStorage<string>(DEVICE_ID_KEY, getOrCreateDeviceId);
  const { promoCodeFromUrl } = usePromoCode();

  const { mutate: trackClick } = useMutation({
    mutationFn: (clickData: { code: string; deviceId: string }) => postData('/campaign-clicks', clickData, 'crm'),
  });

  useEffect(() => {
    if (!promoCodeFromUrl) {
      return;
    }
    trackClick({ code: promoCodeFromUrl, deviceId });
  }, [deviceId, promoCodeFromUrl, trackClick]);
};
